import React, {useState} from 'react';

import HappyGoCashCoins from '@stencil/icons/src/HappyGoCashCoins/HappyGoCashCoins';
import HappyGoCashWhiteTick from '@stencil/icons/src/HappyGoCashWhiteTick/HappyGoCashWhiteTick';

import * as S from './GoCashToggle.styles';

interface GoCashToggleProps {
  isMweb?: boolean;
  maxGoCash: number;
  totalCredits: number;
  onGoCashSelect: () => void;
  onGoCashRemove: () => void;
  info?: string;
  isGoCash: boolean;
  /*@Note this shall be removed once new payment page redirection is live on  dweb and pokus set to 100% */
  payModuleOpen?: boolean;
  disabled?: boolean;
  notConsideredGoCashText?: string;
}

export const GoCashToggle: React.FC<GoCashToggleProps> = ({
  info = '',
  isMweb = false,
  maxGoCash = 0,
  totalCredits = 0,
  onGoCashSelect,
  onGoCashRemove,
  isGoCash,
  payModuleOpen = false,
  disabled = false,
  notConsideredGoCashText = 'Wallet cannot be used with Pay at Hotel bookings',
}) => {
  const toggleGoCash = () => {
    if (payModuleOpen || disabled) return;
    if (isGoCash) {
      onGoCashRemove();
    } else {
      onGoCashSelect();
    }
  };

  const renderGoCashComponent = () => {
    if (!maxGoCash && !disabled) return null;

    return (
      <S.GoCashHeader>
        <S.GoCashTitle>
          <HappyGoCashCoins margin="0 0.5rem 0 0" />
          <span>goCash</span>
        </S.GoCashTitle>
        <S.GoCashToogleWrap>
          {!!isGoCash ? (
            <span className="onText">₹{maxGoCash} Applied</span>
          ) : (
            <span className="offText">Apply ₹{maxGoCash}</span>
          )}
          <S.ToggleBtn>
            <S.ToggleStatus
              className={`${isGoCash ? 'buttonOn' : 'buttonOff'}`}
              onClick={toggleGoCash}
            >
              <S.Tooltip className={`${disabled ? 'disabled' : ''}`}>
                <span className={isGoCash ? 'on' : 'off'}>
                  {isGoCash && <HappyGoCashWhiteTick />}{' '}
                </span>
                {disabled && notConsideredGoCashText && (
                  <S.TooltipText className="hoverText">{notConsideredGoCashText}</S.TooltipText>
                )}
              </S.Tooltip>
            </S.ToggleStatus>
          </S.ToggleBtn>
        </S.GoCashToogleWrap>
      </S.GoCashHeader>
    );
  };

  return (
    <S.GoCashComp isMweb={isMweb}>
      {renderGoCashComponent()}
      {(totalCredits || info) && (
        <S.GoCashDetails>
          {!!totalCredits && (
            <p className="balance">
              <strong>Balance: ₹{totalCredits} goCash</strong>
            </p>
          )}
          {info && <p>{info}</p>}
        </S.GoCashDetails>
      )}
    </S.GoCashComp>
  );
};
